/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetVideoOptions, GetVideoResponses } from '../../models/GetVideo'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Get Video
 * {@link /video/:video_id}
 */
export function getVideo<ThrowOnError extends boolean = true>(options: Options<GetVideoOptions, ThrowOnError>): Promise<UnwrappedResult<GetVideoResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/video/{video_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetVideoResponses, ThrowOnError>>
}
